<template>
  <div class="payment-header__wrap-logo">
    <styled-logo
      v-if="commerceAccountData"
      v-on-clickaway="hideLogoDesc"
      class="payment-header__logo"
      :logo-url="logoUrl"
      :show-default="showDefault"
      @click="showLogoDesc"
      :logo-visible="logoDescIsOpen"
    >
      <SurfaceOverlay class="ph_logo__overlay" />
      <default-svg v-if="showDefault" />
    </styled-logo>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { directive as onClickaway } from 'vue-clickaway';
import DefaultSvg from '@/components/svg/Default';
import styled from 'vue-styled-components';
import { SurfaceOverlay } from '@/components/UI/Material/Overlay';

let logoProps = {
  logoStyles: Object,
  showDefault: Boolean,
  logoUrl: String,
  logoVisible: Boolean,
};

const styledLogo = styled('div', logoProps)`
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-image: url(${props => (!props.showDefault ? props.logoUrl : '')});
  position: relative;
  overflow: hidden;

  &:hover {
    .ph_logo__overlay {
      opacity: 0.03;
    }
    box-shadow: ${props => (props.logoVisible ? 'none' : `var(--box_shadow_hover)`)};
  }

  background-color: var(--surface) !important;
  border-color: var(--on_surface);

  border: var(--border);
  border-radius: var(--border_radius);
  margin-top: 5px;
  svg path {
    fill: var(--on_surface);
    opacity: 0.5;
  }
  transition: var(--default_transition);
`;

export default {
  props: {
    logoDescIsOpen: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['paymentRequest']),
    ...mapState(['commerceAccountData']),

    logoVisible: {
      get() {
        return this.logoDescIsOpen;
      },

      set(val) {
        this.$emit('update:logoDescIsOpen', val);
      },
    },

    logoUrl() {
      return this.commerceAccountData.icon || '';
    },

    showDefault() {
      return this.logoUrl.includes('default');
    },

    logoStyles() {
      let a = {};

      if (!this.showDefault) {
        a['background-image'] = `url(${this.logoUrl})`;
      }

      return a;
    },
  },

  methods: {
    showLogoDesc() {
      this.logoVisible = !this.logoVisible;
    },

    hideLogoDesc() {
      this.logoVisible = false;
    },
  },

  directives: { onClickaway },
  components: { DefaultSvg, styledLogo, SurfaceOverlay },
};
</script>
